import React, { Fragment } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import "./Menu.scss";

// const header_logo = require('../../assets/images/ipsum_city.png');
const header_logo = require(process.env.REACT_APP_HEADER_LOGO)

function Menu(props) {

    const handleLogout = async event => {
        props.onLogout();
          props.history.push('/login');
      };

    return(
        <div className="Menu">
        <Navbar variant="dark" className="p-0" collapseOnSelect  expand="sm" >
            <Navbar.Brand className='p-0'>
            {(localStorage.getItem('user')) ? (
            <a className="title" href="/">
            <img
                src={header_logo}
                className="d-inline-block align-top img-logo"
                alt=""
            />
            </a>
            ):      
            <img
                src={header_logo}
                className="d-inline-block align-top img-logo-b"
                alt=""
            />
            }
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse  id="basic-navbar-nav"  >
            <Nav  className="mr-auto" activeKey="/">
            { props.isAuthenticated ? (
                <Fragment>
                {(props.viewPermissions.find(i => i === 'view_maps_module'))?
                <Nav.Item>
                {(props.viewPermissions.find(i => i === 'view_map'))? <Nav.Link href="/map">Map</Nav.Link>:''}
                </Nav.Item>
                :''}
                {(props.viewPermissions.find(i => i === 'view_reports_module'))?
                <Nav.Item>
                    <NavDropdown title="Reports" id="basic-nav-dropdown">
                    {(props.viewPermissions.find(i => i === 'view_queue_detector'))? <NavDropdown.Item href="/queue">Queue Detector</NavDropdown.Item> :''}
                    {(props.viewPermissions.find(i => i === 'view_queue_det_trend'))? <NavDropdown.Item href="/queue_trend">Queue Detector Trend</NavDropdown.Item> :''}
                    {(props.viewPermissions.find(i => i === 'view_red_light_speed_detector'))? <NavDropdown.Item href="/red_light_speed">Red Light Speed Detector</NavDropdown.Item> :''}
                    {(props.viewPermissions.find(i => i === 'view_speed_report'))? <NavDropdown.Item href="/speed_report">Speed Report</NavDropdown.Item> :''}
                    {(props.viewPermissions.find(i => i === 'view_veh_active_travel'))? <NavDropdown.Item href="/veh_active_travel">Vehicles v Active Travel</NavDropdown.Item> :''}
                    {(props.viewPermissions.find(i => i === 'view_vehicle_detector'))? <NavDropdown.Item href="/report">Vehicle Detector</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'view_vehicle_det_trend'))? <NavDropdown.Item href="/report_trend">Vehicle Detector Trend</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'view_vehicle_det_annual_trend'))? <NavDropdown.Item href="/report_trend_veh">Vehicle Detector Annual Trend</NavDropdown.Item>:''}
                    </NavDropdown>
                </Nav.Item>
                :''}
                {(props.viewPermissions.find(i => i === 'view_assets_module'))?
                <NavDropdown title="Sites" id="basic-nav-dropdown">
                    {(props.viewPermissions.find(i => i === 'view_site_list'))?<NavDropdown.Item href="/sites">Site Configuration</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'view_asset_list'))?<NavDropdown.Item href="/devices">Sensor Configuration</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'view_data_update'))?<NavDropdown.Item href="/devices_upd">Data Update</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'view_annual_subs'))?<NavDropdown.Item href="/devices_as">Annual Subscriptions</NavDropdown.Item>:''}
                </NavDropdown>
                :''}
                {(props.viewPermissions.find(i => i === 'view_users_module'))?
                <NavDropdown title="Users" id="basic-nav-dropdown">
                    {(props.viewPermissions.find(i => i === 'add_users'))?<NavDropdown.Item href="/signup">Add User</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'view_user_list'))?<NavDropdown.Item href="/users">Users</NavDropdown.Item>:''}
                    {(props.viewPermissions.find(i => i === 'edit_users'))?<NavDropdown.Item href="/custom_profile">Custom Profile</NavDropdown.Item>:''}

                </NavDropdown>
                :''}
                <Nav.Item>
                {(props.viewPermissions.find(i => i === 'view_asset_list'))? <Nav.Link href="/assets_connections">Assets Connections</Nav.Link>:''}
                </Nav.Item>
                </Fragment>
            ) : ''}
            </Nav>

            { props.userFullname ? (
                <Navbar.Text className="text-bar ml-2 mr-2">{props.userFullname}</Navbar.Text>
            ): <Navbar.Text className="p-2"></Navbar.Text>
            }
            { props.isAuthenticated ? (
            <Form inline>
                <Button className="ml-2 mr-2" variant="outline-warning" size="sm" onClick={handleLogout}>Logout</Button>
            </Form>
            ): ''
            }
            </Navbar.Collapse>
        </Navbar>
        </div>
    )
}



export default Menu;
